export const isHTML = (str: string) => {
  return /<[a-z][\s\S]*>/i.test(str)
}
